<template>
  <v-date-picker
    ref="month_picker"
    v-model="period_sync"
    :allowed-dates="checkMonthAvailable"
    class="elevation-0 month-calendar main__light_green"
    :class="className"
    color="var(--v-secondary__green_not_active-base)"
    first-day-of-week="1"
    :locale="$i18n.locale"
    :max="maxDate"
    :min="minDate"
    no-title
    :picker-date.sync="year"
    :range="range"
    scrollable
    type="month"
    width="306"
    @change="changeDate"/>
</template>
<script>
import moment from 'moment'
import { datePickerMixin } from 'mixins'

export default {
  name: 'monthPicker',
  mixins: [ datePickerMixin ],
  data() {
    return {
      year: ''
    }
  },
  props: {
    period: [Array, String],
    month: {
      type: String,
      default: () => moment().format('YYYY-MM')
    },
    className: String,
    date_to: String,
    date_from: String,
    range: Boolean,
    with_allowed_dates: Boolean,
    'min-date': String,
    'max-date': String,
    isMonthAvailable: {
      type: Function,
      default: () => () => true // По умолчанию все месяцы доступны
    }
  },
  created() {
  },
  computed: {
    period_sync: {
      get() {
        this.$_customizeMonths()
        if (typeof this.period === 'string') {
          return this.range ? [this.period] : [this.period]
        }
        if (this.range && (!this.period[0] || !this.period[1])) {
          return this.period[0] || this.period[1]
        }
        return this.period
      },
      set(value) {
        // v-date-picker всегда отдаёт массив, но если range=false, отдаём строку
        if (!this.range && Array.isArray(value)) {
          this.$emit('update:period', value[0])
        } else {
          this.$emit('update:period', value.sort())
        }
      }
    },
  },
  methods: {
    chooseDate(date) {
      this.$emit('chooseDate', date)
      this.$_customizeMonths()
    },
    changeDate(date) {
      this.$emit('changeDate', date)
      this.$_customizeMonths()
    },
    checkMonthAvailable(month) {
      return this.isMonthAvailable(month)
    }
  },
  watch: {
    year() {
      this.$_customizeMonths()
    }
  }
}
</script>
<style lang="scss">
.month-calendar {
  .v-picker__body {
    background-color:  var(--v-main__light_green-base) !important ;
    table {
      border-spacing: 0;
    }
    td {
      &:first-child {
        .v-btn--active {
          border-radius: 30px 0 0 30px;
          &.to {
            border-radius: 30px  ;
          }
        }
      }
      &:last-child {
        .v-btn--active {
          border-radius:  0 30px 30px  0 ;
          &.from {
            border-radius: 30px  ;
          }
        }
      }
      .v-btn--active {
        padding: 0;
        background-color: var(--v-secondary__green_chosen-base) !important;
        color: var(--black-color);
        &::before {
          opacity: 0 !important;
        }
        &.active {
          border-radius: 0 ;
        }
        &.from {
          border-radius: 30px 0 0 30px ;
        }
        &.to {
          border-radius:  0 30px 30px  0 ;
        }
        &.rounded {
          border-radius: 30px !important;
        }
        &.rounded, &.to, &.from {
          .v-btn__content{
            border-radius: 30px;
            background-color: var(--v-main__green-base) !important;
            height: 100%;
            width: 100%;
          }
        }
      }
    }

  }
}
.v-date-picker-header__value button {
  text-transform: capitalize;
}
</style>
